import {
  BackgroundRemoverInsufficientCreditsError,
  BackgroundRemoverNotConfiguredError,
  ErrorCode,
  NativeRemoveBackgroundBase64Result,
  RemoveBackgroundBase64Result,
} from "@towersystems/roam-common/lib/generated-types";

export function isRemoveBackgroundBase64Result(
  result: NativeRemoveBackgroundBase64Result
): result is RemoveBackgroundBase64Result {
  if ((result as any).base64) {
    return true;
  }
  return false;
}

export function removalResultToErrorMessage(
  result:
    | BackgroundRemoverNotConfiguredError
    | BackgroundRemoverInsufficientCreditsError
) {
  switch (result.errorCode) {
    case ErrorCode.BACKGROUND_REMOVER_NOT_CONFIGURED_ERROR:
      return "Background remover not configured";
    case ErrorCode.BACKGROUND_REMOVER_INSUFFICIENT_CREDITS_ERROR:
      return "Insufficient credits to remove background";
    default:
      return ErrorCode.UNKNOWN_ERROR;
  }
}
